module.exports = __webpack_public_path__ + "static/img/tc04.13e6123.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/jingmai/tc04.png
// module id = 173
// module chunks = 0